export function sortByCode<T extends { code?: string }>(elA: T, elB: T): number {
  return (elA.code || '').localeCompare(elB.code || '', undefined, { numeric: true });
}
